import { render, staticRenderFns } from "./EmailToNotify.vue?vue&type=template&id=55bbbb0d&scoped=true"
import script from "./EmailToNotify.vue?vue&type=script&lang=js"
export * from "./EmailToNotify.vue?vue&type=script&lang=js"
import style0 from "./EmailToNotify.vue?vue&type=style&index=0&id=55bbbb0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bbbb0d",
  null
  
)

export default component.exports